import * as upload        from './upload';
import * as files          from './files';

export default ({
  upload,
  files
});